﻿import * as React from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormElementViewModel from '../../ViewModels/FormElementViewModel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { TextValidator } from 'react-material-ui-form-validator';

interface IProps {
    element: FormElementViewModel;
    onChange: (value: string, key: number) => void;
    setShouldSubmit: (key: number) => void;
}

export default function OptionalTextCheckboxInput(props: IProps) {
    const { element, onChange, setShouldSubmit } = props;
    const [checked, setChecked] = React.useState<boolean>(element.value !== "" && element.value !== null);

    React.useEffect(() => {
        setShouldSubmit(element.id);
    }, []);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value, element.id);
    }

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
        if (event.target.checked === false)
            onChange("", element.id);
    }

    const limit = element.charLimit > 0 ? { maxLength: element.charLimit } : {};

    return (
        <React.Fragment>
            <Grid item xs={12} md={10}>
                <Typography style={{ textAlign: 'justify' }}>{element.text}</Typography>
            </Grid>
            <Grid item xs={12} md={2} style={{ textAlign: 'right' }}>
                <Checkbox
                    name='checkbox'
                    color="secondary"
                    checked={checked}
                    onChange={handleCheckboxChange}
                    inputProps={{ 'aria-label': element.friendlyName + ' checkbox' }}
                    icon={<CheckBoxOutlineBlankIcon style={{ fontSize: '2.5rem' }} />}
                    checkedIcon={<CheckBoxIcon style={{ fontSize: '2.5rem' }} color="primary" />}
                />
            </Grid>
            {checked &&
                <><Grid item xs={12}>
                    <Typography style={{ textAlign: 'justify' }}>List External Sheet File Names Here</Typography>
                </Grid>
                    <Grid item xs={12} style={{ textAlign: 'right' }}>
                        <TextValidator
                            multiline
                            name={element.documentPlaceholder}
                            fullWidth
                            value={element.value ?? ''}
                            onChange={handleChange}
                            inputProps={limit}
                            InputProps={{
                                style: { color: '#1616b1' }
                            }}
                            validators={element.required ? ['required'] : []}
                            errorMessages={element.required ? ['This field is required'] : []}
                        />
                    </Grid>
                </>}
        </React.Fragment>
    );
}